<template>
  <div class="detail-lcd">
    <div class="detail-lcd__banner">
      <div v-if="imgLoaded" class="detail-lcd__banner__action">
        <div class="detail-lcd__banner__action__save">
          <button class="btn-regular secondary" @click="saved">
           <i class="adx-ic_plus"></i>
           <span>Save</span>
          </button>
        </div>
        <div class="detail-lcd__banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggle" :disabled="!isPhotosAvailable">
            View Photos
          </button>
        </div>
      </div>
      <adx-detail-slider :class="isPhotosAvailable ? 'detail-lcd__banner__img' : 'detail-lcd__banner__placeholder'"
      :slide="1" :isDetail="true" :isCenterMobile="false" :arrowMobile="false" :data="isPhotosAvailable ? detailSlider : placeholderImage" />
    </div>
    <div v-if="!infoLoaded" class="loading-container">
      <adx-loading />
    </div>
    <!-- left detail content -->
    <div v-else class="detail-lcd__info">
      <div class="detail-lcd__info__left">
        <div class="detail-lcd__info__left__header">
          <adx-label-custom :color="'#c283fa'" :label="'Airlines'"/>
          <h2 class="large-title title">{{lcdDetail.title}}</h2>
          <span class="detail-lcd__info__left__header--placement subhead">{{channel_type}} . {{lcdDetail.placement}}</span>
        </div>
        <div class="detail-lcd__info__left__media-package">
          <div class="detail-lcd__info__left__media-package__title">
            <h2 class="regular-font uppercase">Media Package</h2>
          </div>
          <div class="detail-lcd__info__left__media-package__content">
            <p class="subhead">{{lcdDetail.description}}</p>
          </div>
        </div>
        <!-- <div class="detail-lcd__info__left__media"> -->
          <!-- <div class="detail-lcd__info__left__media__title">
            <h2 class="regular-font">Media Details</h2>
          </div> -->
          <!-- <div class="detail-lcd__info__left__media__content">
            <div v-if="media.size"  class="detail-lcd__info__left__media__content--item" >
              <span>Size <strong>{{ media.size }} {{media.measurement_unit}}</strong></span>
            </div>
            <div v-if="media.material" class="detail-lcd__info__left__media__content--item">
              <span>Material <strong>{{ media.material }}</strong></span>
            </div>
            <div v-if="media.playback" class="detail-lcd__info__left__media__content--item">
              <span>Playback <strong>{{ media.playback }}</strong></span>
            </div>
            <div v-if="media.total_spot" class="detail-lcd__info__left__media__content--item">
              <span>Total Spot <strong>{{ media.total_spot }}</strong></span>
            </div>
            <div v-if="media.placement"  class="detail-lcd__info__left__media__content--item">
              <span>Placement <strong>{{ media.placement }}</strong></span>
            </div>
            <div v-if="media.duration"  class="detail-lcd__info__left__media__content--item">
              <span>Duration <strong>{{ media.duration }}</strong></span>
            </div>
          </div>
        </div> -->
        <div class="detail-lcd__info__left__about">
          <div class="detail-lcd__info__left__about__title">
            <h2 class="regular-font">About Location</h2>
          </div>
          <div class="detail-lcd__info__left__about__content">
            <p class="subhead">{{lcdDetail.locDesc}}</p>
          </div>
        </div>
        <div class="detail-lcd__info__left__operatinghour">
          <div class="detail-lcd__info__left__operatinghour__title">
            <h2 class="regular-font">Operation Hours</h2>
          </div>
          <div class="detail-lcd__info__left__operatinghour__content">
            <div class="detail-lcd__info__left__operatinghour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
              <span class="days">{{operatinghour.day}}</span>
              <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">{{operatinghour.time}}</span>
            </div>
          </div>
        </div>
        <div class="detail-lcd__info__left__surrounding">
          <div class="detail-lcd__info__left__surrounding__title">
            <h2 class="regular-font">Surrounding</h2>
          </div>
          <div class="detail-lcd__info__left__surrounding__content">
            <p class="subhead">{{ lcdDetail.surrounding }}</p>
          </div>
        </div>   
        <div class="detail-lcd__info__left__traffic">
          <div class="detail-lcd__info__left__traffic__title">
            <h2 class="regular-font">Traffic</h2>
          </div>
          <div class="detail-lcd__info__left__traffic__content">
            <span>Monthly Traffic : {{ lcdDetail.traffic }} Visitors</span>
          </div>
           <div class="detail-lcd__info__left__traffic__content">
            <i class="adx-ic_cards"></i>
            <span class="item">Average Spending  {{traffic.spending | formatMoney}} /person/visit</span>
          </div>
          <div class="detail-lcd__info__left__traffic__content">
            <i class="adx-ic_briefcase"></i>
            <span class="item">{{traffic.occupation}}</span>
          </div>
          <div class="detail-lcd__info__left__traffic__content">
            <i class="icon-knowledge-base"></i>
            <span class="item">{{traffic.visitor_profile}}</span>
          </div> 
        </div>
      </div>
      <!-- right detail content -->
      <div class="detail-lcd__info__right">
        <div class="detail-lcd__info__right__price">
          <h4 class="subhead title">Price per month</h4>
          <h3 class="medium-title price">{{lcdDetail.price|formatMoney}}</h3>
        </div>
        <div class="detail-lcd__info__right__forbidden">
          <div class="detail-lcd__info__right__forbidden--title">
            <i class="icon-warning"></i>
            <h3>Forbidden Advertisement</h3>
          </div>
          <div class="detail-lcd__info__right__forbidden--content">
            <p>{{lcdDetail.forbidden}}</p>
          </div>
        </div>
         <div class="detail-lcd__info__right__address">
          <div class="detail-lcd__info__right__address--title">
            <i class="icon-pin"></i>
            <h3>Address</h3>
          </div>
          <div class="detail-lcd__info__right__address--content">
            <p>{{lcdDetail.address}}</p>
          </div>
        </div>
        <div class="detail-lcd__info__right__action">
          <button class="btn-large primary add" @click="showCampaign">Add to Campaign</button>
        </div>
      </div>
    </div>
    <div v-if="infoLoaded" class="detail-lcd__footer">
      <div class="detail-lcd__footer__left">
        <p class="micro-font title">Price per month</p>
        <p class="medium-title price">{{lcdDetail.price|formatMoney}}</p>
      </div>
      <div class="detail-lcd__footer__right">
        <button class="btn-large btn-block primary" @click="showCampaign">Add to Campaign</button>
      </div>
    </div>
    <adx-modal v-if="isOpen" @modal-close="toggle" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="detailSlider" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{lcdDetail.title}}</span>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DetailSlider from '@/components/Slider/DetailSlider'
import Modal from '@/components/Modal'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import LoadingPrimary from '@/components/Loading/Primary'
import LabelStatus from '@/components/StatusLabel'
import CategoryJumbotron from '@/components/Jumbotron/Category'
import LabelStatusCustom from '@/components/StatusLabelCustom'
import api from '@/api'
import { airlinesParams } from '@/api/params'
import { apiV2 } from '@/api/urls'
import { formatNumber } from '@/lib/filter'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-am_lcd',
  components: {
    'adx-detail-slider': DetailSlider,
    'adx-modal': Modal,
    'adx-loading-circle': LoadingSecondary,
    'adx-loading-spin': LoadingSpin,
    'adx-loading': LoadingPrimary,
    'label-status': LabelStatus,
    'category-jumbotron': CategoryJumbotron,
    'adx-label-custom': LabelStatusCustom
  },
  props: {

  },
  data() {
    return {
      channel_type:'LCD Screen',
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isMobile: window.innerWidth < 769,
      isShownCampaign: false,
      campaigns: [],
      category: 'lifestyle',
      lcdDetail: {
        title: ``,
        placement: ``,
        locDesc: ``,
        description: ``,
        surrounding: ``,
        forbidden: ``,
        address: ``,
        price: null,
      },
      placeholderImage:[{
        id: 0,
        url: `/img/notfound/img-placeholder_landscape.jpg`,
        thumbnail : `/img/notfound/img-placeholder_landscape.jpg`,
        is_primary: false,
        caption: 'placeholder'
      }],
      traffic:{
        visitor: null,
        spending: null,
        occupation: null,
        visitor_profile: null,
      },
      media: {
        size: null,
        material: null,
        measurement_unit: null,
        playback: null,
        min_order: null,
        total_spot: null,
        placement: null,
        duration: null,
      },
      detailSlider: [],
      OperatingHours: [],
      isOpen: false,
      currentSlide: 1,
      countSlide: null,
      pub_id: null,
      deviceId: null,
      imgLoaded: false,
      infoLoaded: false,
      savedLoading: false,
      isAudienceDisplayed: null,
      params: null
    }
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
    isPhotosAvailable(){
      return this.detailSlider.length > 0
    },
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { pub_id } = this.$route.params
    this.pub_id = pub_id
    const categoryName = this.$options.name.split(`-`).pop()
    this.params = { ...airlinesParams[categoryName]}
    
    this.loadData()
    this.loadImage()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    showCampaign(){

    },
    loadData () {
      (async () => {
        const { data } = await api.get(apiV2.airlinesDetail(this.pub_id), { params: this.params , needToken: true })
        this.mapData(data)
        this.infoLoaded = true
      })();
    },
    loadImage () {
      (async () => {
        this.detailSlider = []
        const { data } = await api.get(apiV2.airlinesDetailImage(this.pub_id), { params: this.params , needToken: true })
        let isPrimaryExist = false
        let image = []
        data.map(el => {
          if(el.is_primary){
            isPrimaryExist = true
            image.push({
              id: el.id,
              url: el.image,
              thumbnail : el.thumbnail_720,
              is_primary: el.is_primary,
              caption: el.caption
            })
          }
        })
        this.imgLoaded = true
        if (!isPrimaryExist && data.length > 0){
          let firstPic = data[0]
          this.detailSlider.push({
            id: firstPic.id,
            url: firstPic.image,
            thumbnail : firstPic.thumbnail_720,
            is_primary: firstPic.is_primary,
            caption: firstPic.caption
          })
        } else if (image.length > 0 ){
          this.detailSlider.push(image[0])
        }
      })();
    },
    mapData (data) {
      this.lcdDetail = {
        title: data.location_inside.title,
        placement: data.placement,
        locDesc: data.location_inside.about,
        description: data.description,
        surrounding: data.surrounding,
        forbidden:  (data.forbidden_ads ? data.forbidden_ads : 'There\'s no Forbidden Ads'),
        address: (data.address ? data.address : 'N/A'),
        price: data.price,
      }
      let purchaseResc = '-'
      if (data.purchase_restriction){
        purchaseResc = data.purchase_restriction.min_quantity + ' ' + data.purchase_restriction.min_period_type 
      }
      this.media = {
        min_order: purchaseResc,
        size: data.size,
        material: data.material,
        playback: data.playback_per_day + ' Per Day' ,
        min_order: (data.purchase_restriction ? data.purchase_restriction + ' Month' : '-'),
        total_spot: data.quantity,
        placement: data.placement,
        duration: data.adx_duration + ' Second',
      }
      this.traffic = {
        visitor: data.location_inside.traffic,
        spending: (data.location_inside.spending_average ? data.location_inside.spending_average : 0),
        occupation: ` Occupation ${data.profile.job.join(` `)}`,
        visitor_profile: ` Visitor Profile ${data.profile.ses.join(` `)}`,
      }
      this.OperatingHours = data.operating_hours.map(el => {
        let data = {}
        data.day = el.day
        data.isOpen = el.is_open
        if (el.is_open) {
          data.time = `${el.start} - ${el.end}`
        } else {
          data.time = 'closed'
        }
        return data
      })
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    saved() {
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: `Data successfully saved!`,
        type: 'success'
      });
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'index';
@import '~@/styles/variables';
@import '~@/styles/mixins';
.uppercase{
  text-transform: uppercase;
}
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.detail-lcd__banner__placeholder {
  .slick-slide {
    img.detail {
      object-fit: unset;
    }
  }
}

.detail-lcd__banner__img {
  .slick-slide {
    widows: 100;
  }
  .slick-slide:first-child{
    margin-left: 0px;
  }
}

@include breakpoint(md) {
  .detail-lcd__banner__img {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
  .detail-lcd__banner__placeholder {
    .slick-slide {
      img.detail {
        height: 260px;
      }
    }
  }
}
</style>
